import React, { Fragment } from "react";
import styled from "styled-components";

import { IRightCheck } from "./lib/DataTable.type";
import { AnimatedWrapper } from "./lib/animationStyle";
import { useLocation } from "react-router-dom";
import { transferToNative } from "@src/lib/WebAppBridge";

const URL = process.env.NEXT_PUBLIC_URL;

const AuctionRightCheckPreview = ({ auctionData }: { auctionData: IRightCheck }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const itemId = searchParams.get("itemId") ?? "";

    let etcNote = auctionData?.etc_note;
    if (etcNote?.startsWith("\n")) {
        etcNote = etcNote.substring(1);
    }
    etcNote = etcNote?.split("\n").map((item: string, idx: number) => (
        <Fragment key={idx.toString()}>
            {item}
            <br />
        </Fragment>
    ));

    return (
        <AnimatedWrapper>
            {auctionData?.lessee_type === "2" ? (
                <NoneItemBox>
                    <div className="titleContainer">
                        <p>임차인현황</p>
                    </div>
                    <div className="contents">전부를 소유자가 점유합니다</div>
                </NoneItemBox>
            ) : auctionData?.lessee_type === "3" ? (
                <NoneItemBox>
                    <div className="titleContainer">
                        <p>임차인현황</p>
                    </div>
                    <div className="contents">조사된 임차 내역이 없어요.</div>
                </NoneItemBox>
            ) : auctionData?.lessee_type === "4" ? (
                <NoneItemBox>
                    <div className="titleContainer">
                        <p>임차인현황</p>
                    </div>
                    <div className="greyContents">
                        해당 물건은 신건으로, 매각물건명세서가 나오지 않아 입찰일 7일 전 제공될 예정입니다
                    </div>
                </NoneItemBox>
            ) : auctionData?.lessee_type === "5" ? (
                <NoneItemBox>
                    <div className="titleContainer">
                        <p>임차인현황</p>
                    </div>
                    <div className="greyContents">해당 물건은 매각물건명세서가 나오지 않아 입찰일 7일 전 제공될 예정입니다</div>
                </NoneItemBox>
            ) : auctionData?.lessee_type === "6" || auctionData?.lessee_type === "7" ? (
                <NoneItemBox>
                    <div className="titleContainer">
                        <p>임차인현황</p>
                    </div>
                    <div className="greyContents">이 물건의 매각물건명세서는 아직 수집되지 않았어요 </div>
                </NoneItemBox>
            ) : (
                <>
                    <MainWrapper>
                        <div className="titleContainer">
                            <p>임차인현황</p>
                            {auctionData?.total_counter_force && <span>대항력있음</span>}
                        </div>

                        <div className="infoChartBox">
                            <div className="infoChart">
                                <div className="titleBox">말소기준권리</div>
                                <div className="descBox">{auctionData?.expunge_right.split("\n")[0]}</div>
                            </div>
                            <div className="infoChart">
                                <div className="titleBox">배당요구종기</div>
                                <div className="descBox">{auctionData?.distrib_req_duedate}</div>
                            </div>
                        </div>
                    </MainWrapper>
                    <MainWrapper>
                        {auctionData?.lessee_list?.map((lessee, idx) => (
                            <table key={idx}>
                                <thead>
                                    <tr>
                                        <th>임차인</th>
                                        <th>전입/확정/배당</th>
                                        <th>보증금/임차인</th>
                                        <th>대항력</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan={3}>{lessee.lessee}</td>
                                        <td>
                                            <div className="tableType">전입</div>
                                            <div className="tableData">{lessee.transfer_date}</div>
                                        </td>
                                        <td rowSpan={3}>
                                            <div className="descBox1">
                                                <div className="depositContainer">
                                                    <span className="depositBox1">보</span>
                                                    <a
                                                        className="textSpaceTd3"
                                                        onClick={() =>
                                                            transferToNative(
                                                                JSON.stringify({
                                                                    type: "Guarantee",
                                                                    itemId: itemId,
                                                                    lessee: lessee,
                                                                }),
                                                                "onMissgoAIClicked",
                                                            )
                                                        }
                                                    >
                                                        {lessee.deposit}
                                                    </a>
                                                </div>
                                            </div>
                                            {lessee.fee === "-" ||
                                            lessee.fee === "미상" ||
                                            lessee.fee === "0원" ||
                                            lessee.fee === "0" ? (
                                                ""
                                            ) : (
                                                <div className="descBox1">
                                                    <span className="feeBox">월</span>
                                                    <p>{lessee.fee}</p>
                                                </div>
                                            )}
                                        </td>
                                        <td rowSpan={3}>
                                            {lessee.counter_force_str === "있음" ? (
                                                <p style={{ color: "red" }}>있음</p>
                                            ) : (
                                                <p>{lessee.counter_force_str}</p>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="tableType">확정</div>
                                            <div className="tableData">{lessee.confirm_date}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="tableType">배당</div>
                                            <div className="tableData">{lessee.distrib_req_date}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>점유부분 : {lessee.occu_part}</td>
                                    </tr>

                                    {lessee.acquisition_amount && (
                                        <tr>
                                            <td colSpan={4}>인수금액: {lessee.acquisition_amount}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        ))}
                        <DepositDetailText>
                            <span className="highlight">*</span>보증금 금액을 클릭하면 상세 정보를 확인할 수 있습니다.{" "}
                        </DepositDetailText>
                    </MainWrapper>
                </>
            )}
            <MainWrapper>
                {(auctionData?.lessee_list.length > 0 || auctionData?.total_acquisition_amount !== "0원") && (
                    <div className="totalContainer">
                        {auctionData?.lessee_list.length > 0 && (
                            <>
                                <div className="descBox">
                                    <p>총 임차인 수</p>
                                    <span>{auctionData?.total_lessee_cnt}</span>
                                </div>
                                <div className="descBox">
                                    <p>보증금합계</p>
                                    <span>{auctionData?.total_lease_deposit}</span>
                                </div>
                                <div className="descBox">
                                    <p>월세합계</p>
                                    <span>{auctionData?.total_monthly_rent}</span>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </MainWrapper>
            {auctionData?.etc_note && (
                <TitleTableContainer>
                    <EtcWrapper>
                        <Title>기타사항</Title>
                        <div className="etcDesc textLine">{etcNote}</div>
                    </EtcWrapper>
                </TitleTableContainer>
            )}
        </AnimatedWrapper>
    );
};

const NoneItemBox = styled.div`
    padding: 0 14px;
    display: flex;
    flex-direction: column;
    .titleContainer {
        display: flex;
        height: 36px;
        justify-content: space-between;
        align-items: baseline;
        p {
            color: #0c002c;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 26px;
        }
        span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 68px;
            height: 28px;
            background-color: #ff0000;
            border-radius: 14px;
            color: #fff;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
        }
    }
    .contents {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 72px;
        border-radius: 14px;
        gap: 8px;
        background-color: #ffdad8;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        color: #0c002c;
        margin-bottom: 14px;
    }
    .greyContents {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 72px;
        border-radius: 14px;
        gap: 8px;
        background-color: #f0f0f0;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        color: #a3a3a3;
        margin-bottom: 14px;
        padding: 0px 24px;
    }
`;

const MainWrapper = styled.div`
    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        margin-top: 16px;
        font-size: 14px;

        .tableType {
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
            color: #0c002c;
        }

        .tableData {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            color: #282828;
        }
    }

    th,
    td {
        border: 1px solid #c9c9c9;
        text-align: center;
        vertical-align: middle;
        word-break: keep-all;
    }

    th {
        background-color: #17366d;
        color: white;
        font-size: 12px;
        font-weight: 700;
        line-height: 20px;
        padding: 4px 0;
    }

    thead tr th:nth-child(1) {
        width: 20%;
    }

    thead tr th:nth-child(2) {
        width: 27%;
    }

    thead tr th:nth-child(3) {
        width: 40%;
    }

    thead tr th:nth-child(4) {
        width: 13%;
    }

    tbody {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }

    tbody tr:first-child td:first-child {
        background-color: #edf0f6;
    }

    tbody tr:first-child td:nth-child(2) {
        padding: 6px 10px;
        text-align: left;
    }

    tbody tr:nth-child(2) td {
        padding: 6px 10px;
        text-align: left;
    }

    tbody tr:nth-child(3) td {
        padding: 6px 10px;
        text-align: left;
    }

    tbody tr:last-of-type td,
    tbody tr:nth-last-of-type(2) td[colSpan="4"] {
        background-color: #edf0f6;
        color: #0c002c;
        text-align: left;
        padding: 8px 0 8px 15px;
    }

    .textSpaceTd3 {
        display: flex;
        max-width: 110px;
        cursor: pointer;
        color: #0047ff;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        text-decoration-line: underline;
        text-underline-offset: 3px;
    }
    .descBox1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;

        & .depositContainer {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 4px;
        }
    }
    .depositBox1 {
        display: flex;
        width: 16px;
        height: 16px;
        border-radius: 2px;
        background: rgba(0, 71, 255, 0.8);
        font-size: 12px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding: 1px 1px;
    }
    .descBox {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
    }
    .feeBox {
        display: flex;
        width: 16px;
        height: 16px;
        background-color: #a570f7;
        font-size: 12px;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0px;
        color: #ffffff;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding: 1px 1px;
    }
    .titleContainer {
        display: flex;
        height: 36px;
        justify-content: space-between;
        align-items: baseline;

        p {
            color: #0c002c;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 26px;
        }
        span {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px 5px;
            background-color: #ff0000;
            border-radius: 30px;
            color: #fff;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 140%;
        }
    }
    .totalContainer {
        margin-top: 20px;
        margin-bottom: 8px;
        border: 1px solid #b1aeb8;
        border-bottom: 0;
        .descBox {
            display: flex;
            min-height: 26px;
            border-bottom: 1px solid #b1aeb8;
        }

        p {
            width: 120px;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%;
            color: #ffffff;
            background-color: #17366d;
            text-align: center;
            padding: 12px 13px 12px 13px;

            display: flex;
            align-items: center;
            justify-content: start;

            height: 100%;
            box-sizing: border-box;
        }
        span {
            color: #0c002c;
            font-size: 14px;
            font-weight: 400;
            line-height: 140%;
            padding: 12px 13px 12px 13px;
        }
    }
    .infoChartBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
    }
    .infoChart {
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        border: 1px solid #b1aeb8;
        width: 100%;

        .titleBox {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%;
            background-color: #2275ee;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            padding: 8px 0;
            white-space: nowrap;
        }
        .descBox {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #0c002c;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            padding: 8px 0;
            line-height: 140%;
        }
    }

    @media screen and (max-width: 768px) {
        width: 100%;
        box-sizing: border-box;
        .infoChart {
            .titleBox {
                width: 100%;
            }

            .descBox {
                width: 100%;
            }
        }
    }
`;

const DepositDetailText = styled.p`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    margin-top: 12px !important;
    color: #0c002c !important;

    .highlight {
        color: #f00;
    }
`;

const TitleTableContainer = styled.div`
    box-sizing: border-box;
`;

const EtcWrapper = styled.div`
    gap: 4px;
    white-space: pre-wrap;
    border: 1px solid #b1aeb8;
    box-sizing: border-box;
    .etcDesc {
        padding: 12px 8px;
        color: #0c002c;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        white-space: pre-wrap;
    }

    .etcDesc.textLine {
        text-decoration: underline;
        text-underline-position: under;
        text-decoration-color: #a3a3a3;
    }
`;

const Title = styled.p`
    color: white !important;
    border-bottom: 1px solid #b1aeb8;
    width: 100%;
    font-size: 14px;
    background-color: #17366d;
    font-weight: bold;
    padding: 4px 8px;
    line-height: 24px;
    box-sizing: border-box;
`;

export default AuctionRightCheckPreview;
